@for (option of activeMarket.options; track optionsTrackBy($index, option)) {
    <ms-event-pick
        class="result"
        [option]="option"
        [event]="event"
        [optionGroup]="activeMarket"
        [trackingSource]="tracking.source"
        [trackingGameDetails]="tracking.gameDetails"
        [enableOptionIndicator]="false">
        <ms-tree-option class="card-option" [option]="option" />
    </ms-event-pick>
}
